import type { Position, RatingKey } from './types';

/**
 * The ratings each position is built around. Key ratings are drawn from the team's range,
 * everything else from the off-trait range in tunables.
 */
export const KEY_RATINGS: Record<Position, readonly RatingKey[]> = {
  QB: ['THP', 'THA', 'ACC'],
  RB: ['SPD', 'ACC', 'AGI', 'STR', 'CTH', 'CIT'],
  WR: ['SPD', 'ACC', 'AGI', 'CTH', 'CIT', 'RTE'],
  TE: ['STR', 'CTH', 'CIT', 'RTE', 'BLK'],
  OL: ['STR', 'BLK'],
  DL: ['STR', 'PRS', 'TAK'],
  LB: ['SPD', 'TAK', 'COV', 'PRS'],
  CB: ['SPD', 'ACC', 'AGI', 'COV'],
  S: ['SPD', 'ACC', 'COV', 'TAK'],
  K: ['KPW', 'KAC'],
};
